export const COMPONENT_DEFINITION_DEFAULT_IMAGE_EXTENSION = 'png';
